import { useState } from "react";
import srkCertificationJson from "./srkCertification.json";
import "./certificationStyle.scss";
import fssaiPdf from "../../assets/fssaiPdf/fssai_certificate.pdf";
import { Button } from "antd";
import { AiOutlineSafetyCertificate } from "react-icons/ai";
import { MdOutlinePreview } from "react-icons/md";

export const SrkCertification = () => {
    const [showPdf, setShowPdf] = useState(false);

    return (
        <section className="py-5" style={{ backgroundColor: "#FAF8F2" }}>
            <div className="container">
                <p className="fw-bold text-uppercase small mb-2 text-left">
                    {srkCertificationJson?.info}
                </p>

                <h1
                    className="bebas-neue-regular text-color certification-title mb-3"
                    dangerouslySetInnerHTML={{ __html: srkCertificationJson?.title }}
                />

                <p
                    className="fw-normal certification-desc mb-4"
                    dangerouslySetInnerHTML={{
                        __html: srkCertificationJson?.subContent,
                    }}
                />

                <div className="row g-4 align-items-start">
                    <div className={showPdf ? "col-12 col-lg-8" : "col-12"}>
                        <div className="license-card shadow-sm p-4 rounded-4">

                            <div className="d-flex justify-content-between align-items-center mb-4">
                                <h3 className="bebas-neue-regular fw-bold mb-0 text-color">
                                    FSSAI Central License
                                </h3>
                                <AiOutlineSafetyCertificate style={{ fontSize: "25px" }} />
                            </div>

                            <hr />

                            <div className="row">
                                <p className="col-6 fw-semibold">LICENSE NUMBER</p>
                                <div className="col-6 fw-semibold text-end">
                                    12426997000077
                                </div>
                            </div>

                            <hr />

                            <div className="row">
                                <p className="col-6 fw-semibold">COMPANY NAME</p>
                                <div className="col-6 fw-semibold text-end">
                                    SRK Traders
                                </div>
                            </div>

                            <hr />

                            <div className="row">
                                <p className="col-6 fw-semibold">BUSINESS TYPE</p>
                                <div className="col-6 fw-semibold text-end">
                                    Trader / Merchant / Exporter
                                </div>
                            </div>

                            <hr />

                            <div className="row">
                                <p className="col-6 fw-semibold">LICENSE TYPE</p>
                                <div className="col-6 fw-semibold text-end">
                                    Central License
                                </div>
                            </div>

                            <hr />

                            <div className="row">
                                <div className="col-6">
                                    <p className="fw-semibold">ISSUED DATE</p>
                                    <div>09 Feb 2026</div>
                                </div>

                                <div className="col-6">
                                    <p className="fw-semibold">VALID UNTIL</p>
                                    <div>08 Feb 2027</div>
                                </div>
                            </div>

                            <hr />

                            <div className="col-12">
                                <p className="fw-semibold">LOCATION</p>
                                <div>Pavoorchatram, Tenkasi, Tamil Nadu, India</div>
                            </div>

                            <hr />

                            <div className="col-12">
                                <p className="fw-semibold">ISSUED AUTHORITY</p>
                                <div>
                                    Food Safety and Standards Authority of India
                                </div>
                            </div>

                            <hr className="my-4" />

                            <div className="d-flex justify-content-between flex-wrap gap-3 text-muted small">
                                <div>✔ GOVERNMENT APPROVED</div>
                                <div>✔ EXPORT AUTHORIZED</div>
                                <div>✔ FOOD SAFETY CERTIFIED</div>
                            </div>

                            <Button
                                size="large"
                                icon={<MdOutlinePreview />}
                                type="primary"
                                className="w-100 mt-4 py-2 rounded-3"
                                onClick={() => setShowPdf(!showPdf)}
                            >
                                View Certificate
                            </Button>
                        </div>
                    </div>
                    {showPdf && (
                        <div className="col-12 col-lg-4">
                            <div className="pdf-wrapper shadow-sm overflow-hidden">
                                <iframe
                                    src={`${fssaiPdf}#toolbar=0&navpanes=0&scrollbar=0`}
                                    width="100%"
                                    height="600px"
                                    title="PDF Viewer"
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};